import type { CertGenParams } from '@yandex-int/k-common';

interface Props extends CertGenParams {
    year?: string;
}

export const PYTH1LEV = ({
    school_name: schoolName,
    first_name: firstName,
    middle_name: middleName,
    last_name: lastName,
    year,
}: Props) => {
    return `<!DOCTYPE html>
<html lang="ru">
<head>
    <title>Сертификат за программу обучения «Подготовительный курс по Python для учителей»</title>
    <meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>
    <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
    <style>
        @font-face {
            font-family: 'YS Text';
            src: url('https://yastatic.net/s3/home/fonts/ys/1/text-light.woff2') format('woff2'),
            url('https://yastatic.net/s3/home/fonts/ys/1/text-light.woff') format('woff');
            font-weight: 300;
            font-style: normal;
        }

        @font-face {
            font-family: 'YS Text';
            src: url('https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff2') format('woff2'),
            url('https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff') format('woff');
            font-weight: 400;
            font-style: normal;
        }

        @font-face {
            font-family: 'YS Text';
            src: url('https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff2') format('woff2'),
            url('https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff') format('woff');
            font-weight: 500;
            font-style: normal;
        }

        @font-face {
            font-family: 'YS Text';
            src: url('https://yastatic.net/s3/home/fonts/ys/1/text-bold.woff2') format('woff2'),
            url('https://yastatic.net/s3/home/fonts/ys/1/text-bold.woff') format('woff');
            font-weight: bold;
            font-style: normal;
        }

        @font-face {
            font-family: 'YS Display';
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;

            src: url('//yastatic.net/s3/home/fonts/ys/1/display-bold.woff2') format('woff2'),
            url('//yastatic.net/s3/home/fonts/ys/1/display-bold.woff') format('woff');
        }

        @font-face {
            font-family: 'YS Display';
            font-weight: 800;
            font-style: normal;
            font-stretch: normal;

            src: url('//yastatic.net/s3/home/fonts/ys/1/display-heavy.woff2') format('woff2'),
            url('//yastatic.net/s3/home/fonts/ys/1/display-heavy.woff') format('woff');
        }

        @page {
            size: 210mm 297mm;
            margin: 0;
            padding: 0;
        }

        @media print {
            html,
            body {
                width: 210mm;
                height: 297mm;

                box-sizing: border-box;
            }
        }

        html {
            position: relative;

            margin: 0;
            padding: 0;

            --background-color: #ffffff;
            --text-color: #000000
        }

        body {
            margin: 0;

            color: var(--text-color);

            font-family: 'YS Text', sans-serif;
        }

        .page {
            position: relative;

            overflow: hidden;

            box-sizing: border-box;

            width: 210mm;
            height: 297mm;

            background: var(--background-color);

            page-break-after: always;
        }

        .page__background {
            position: absolute;

            width: 100%;
            height: 100%;
            right: 0;
            top: 0;

            overflow: hidden;

            display: flex;

            z-index: 1;
        }

        .background__rectangle {
            overflow: hidden;

            position: absolute;
            right: 0;
            top: 0;

            height: 100%;
            width: calc(210 / 595 * 172mm);

            background-color: #FFCC00;
        }

        .background__python {
            position: absolute;

            top: calc(297 / 842 * 34mm);
        }

        .background__python-white {
            height: calc(297 / 842 * 423mm);
            margin-top: calc(297 / 842 * 45mm);
        }

        .background__python-yellow {
            position: absolute;
            top: calc(297 / 842 * 36mm);
            left:  calc(210 / 595 * 207mm);
            height: calc(297 / 842 * 470mm);
        }

        .background__white-block {
            height: calc(297 / 842 * 72mm);
            width:  calc(210 / 595 * 115mm);
            background-color: white;
            position: absolute;
            top: calc(297 / 842 * 244mm);
            left:  calc(210 / 595 * 207mm);
        }

        .page__content {
            height: 100%;
            width: 100%;

            position: relative;
            z-index: 2;
        }

        .content {
            box-sizing: border-box;

            display: flex;

            z-index: 2;

            flex-direction: column;

            width: calc(210 / 595 * 304mm);

            margin-left:  calc(210 / 595 * 48mm);
            margin-top: calc(297 / 842 * 48mm);

            color: var(--text-color);
        }

        .content__logo {
            width: calc(210 / 595 * 159mm);
            height: calc(297 / 842 * 20mm);
        }

        .logo {
            width: 100%;
        }

        .content__title {
            height: calc(297 / 842 * 50mm);

            margin-top: calc(297 / 842 * 225mm);

            font-family: 'YS Display', 'Arial', sans-serif;
            font-weight: 700;
            font-size: 40pt;
        }

        .content__subtitle {
            font-family: 'YS Text', 'Arial', sans-serif;
            font-style: normal;
            font-weight: 400;
            height: calc(297 / 842 * 16mm);
        }

        .content__personal-info {
            margin-top: calc(297 / 842 * 32mm);
        }

        .personal-info {
            display: flex;
            flex-direction: column;

            height: calc(297 / 842 * 236mm);
        }

        .personal-info__name {
            font-family: 'YS Display', 'Arial', sans-serif;
            font-weight: 700;
            font-size: 28pt;
            line-height: 30pt;
        }

        .personal-info__school {
            margin-top: calc(297 / 842 * 12mm);

            font-family: 'YS Text', 'Arial', sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 14pt;
            line-height: 16pt;
        }

        .personal-info__description {
            font-family: 'YS Text', 'Arial', sans-serif;
            font-style: normal;
            font-weight: 500;
            font-size: 14pt;
            line-height: 16pt;

            margin-top: calc(297 / 842 * 12mm);
        }

        .footer {
            display: flex;
            flex-direction: column;

            margin-top: calc(297 / 842 * 105mm);
        }

        .person {
            display: flex;
            flex-direction: column;
        }

        .person__name {
            font-family: 'YS Text', 'Arial', sans-serif;
            font-weight: 500;
            font-size: 13pt;
            line-height: 12pt;
        }

        .person__position {
            margin-top: calc(297 / 842 * 8mm);

            font-family: 'YS Text', 'Arial', sans-serif;
            font-weight: 400;
            font-size: 12pt;
            line-height: 15pt;
        }

        .seal {
            position: absolute;

            height: calc(297 / 842 * 130mm);
            width: calc(210 / 595 * 130mm);

            top: calc(297 / 842 * 635mm);
            left: calc(210 / 595 * 193mm);
        }

        .seal__image {
            height: 100%;
            width: 100%;
        }

        .date {
            position: absolute;

            top: calc(297 / 842 * 786mm);
            left: 50%;
            transform: translateX(-50%);

            font-family: 'YS Text', 'Arial', sans-serif;
            font-weight: 400;
            font-size: 10pt;
            line-height: 130%;
        }
    </style>
</head>
<body>
<div class="page">
    <div class="page__content content content__main">
        <div class="content__logo">
            <img class="logo"
                 src="https://e7n.s3.yandex.net/static/certificates/2022-autumn-diag-inf/logo.svg"
                 alt="Яндекс Учебник">
        </div>
        <div class="content__title">
            Сертификат
        </div>
        <div class="content__subtitle">
            подтверждает, что
        </div>
        <div class="content__personal-info personal-info">
            <div class="personal-info__name name">
                ${lastName ? `${lastName}` : ''}<br>
                ${firstName ? `${firstName}` : ''}<br>
                ${middleName ? `${middleName}` : ''}
            </div>
            <div class="personal-info__school school">
                ${schoolName ? `${schoolName}` : ''}
            </div>
            <div class="personal-info__description">
                успешно прошел(-а) программу обучения «Подготовительный курс по Python для учителей» на платформе Яндекс Учебник
            </div>
        </div>
        <div class="footer">
            <div class="footer__person person">
                <div class="person__name">Растворов Д. А.</div>
                <div class="person__position">
                    Директор по взаимодействию<br />с органами власти в сфере<br />образования ООО «Яндекс»
                </div>
            </div>
        </div>
        <div class="seal">
            <img
                class="seal__image"
                src="https://e7n.s3.yandex.net/static/certificates-images/sign_da.png"
                alt="подпись Растворова"
            />
        </div>
    </div>
    <div class="page__background">
        <div class="background__python">
            <img class="background__python-yellow"
                 src="https://e7n.s3.yandex.net/static/certificates/TeacherIntroductionToPython/python_yellow.png">
            <div class="background__white-block"></div>
        </div>
        <div class="background__rectangle">
            <div class="background__python">
                <img class="background__python-white"
                     src="https://e7n.s3.yandex.net/static/certificates/TeacherIntroductionToPython/python_white.png">
            </div>

            <div class="date">Москва, ${year}</div>
        </div>
    </div>
</div>
</body>
</html>
`;
};
